import { EScope } from '@/features/roles/store/models/role.model';
import { ISupportUser } from '@/features/dashboard-users/store/support-user.model';

export function getSupportUserScopes(user: ISupportUser): EScope[] {
  const scopes = user.clients
    ?.map((client) => client.scopes)
    .reduce((allScopes, scopes) => [...allScopes, ...scopes], []);
  const uniqueScopes: EScope[] = [...new Set(scopes)] as EScope[];
  return uniqueScopes;
}
